export const BD_EXPORT_AS_FILE_DEFAULT_CONFIG: BdExportAsFileConfig = {
  authenticationStrategy: 'always',
  trigger: { tooltipText: 'Export', dataTestKey: 'export-trigger' },
  form: {
    availableExportTypes: ['csv', 'xlsx'],
  },
};

/**
 * Strategy for authentication
 * - always: only show the export button if the user is authenticated
 * - never: always show the export button
 * - contact: show the export button; if the user is not authenticated show a contact form
 * - reduce: show the export button; if the user is not authenticated deliver a reduced export
 */
export type BdExportAsFileAuthenticationStrategy =
  | 'always'
  | 'never'
  | 'contact'
  | 'reduce';

/**
 * Configuration for the authentication strategy
 * - resultSetCount: the maximum number of rows to export
 */
export interface BdExportAsFileAuthenticationStrategyReduceConfig {
  resultSetCount: number;
}

export interface BdExportAsFileAuthenticationStrategyContactConfig {
  portalId: string;
  formId: string;
}

/**
 * Configuration for the button which triggers the export dialog
 */
export interface BdExportAsFileTriggerConfig {
  tooltipText: string;
  dataTestKey: string;
}

export interface BdExportAsFileFormConfig {
  defaultLabels?: string[];
  availableExportTypes: ('csv' | 'xlsx')[];
}

export interface BdExportAsFileConfig {
  authenticationStrategy: BdExportAsFileAuthenticationStrategy;
  authenticationStrategyConfig?:
    | BdExportAsFileAuthenticationStrategyContactConfig
    | BdExportAsFileAuthenticationStrategyReduceConfig;
  trigger: BdExportAsFileTriggerConfig;
  form: BdExportAsFileFormConfig;
}
